import { styled, css } from '@acko-tech/building-blocks.ui.common';

import {
    H1 as AuiH1,
    H2 as AuiH2,
    H3 as AuiH3,
    H4 as AuiH4,
    H5 as AuiH5,
    H6 as AuiH6,
    H7 as AuiH7,
    Price as AuiPrice,
    SubHeading as AuiSubHeading,
} from '@acko-tech/building-blocks.ui.typography';

export const subHeading2 = css`
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 17px;
`;

export const textColor = css`
    color: #040222;
`;

export const description = css`
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
`;

export const ExtAuiH1 = styled(AuiH1)`
    ${textColor}
`;

export const ExtAuiH2 = styled(AuiH2)`
    ${textColor}
`;
export const ExtAuiH3 = styled(AuiH3)`
    ${textColor}
`;
export const ExtAuiH4 = styled(AuiH4)`
    ${textColor}
`;
export const ExtAuiH5 = styled(AuiH5)`
    ${textColor}
`;
export const ExtAuiH6 = styled(AuiH6)`
    ${textColor}
`;
export const ExtAuiH7 = styled(AuiH7)`
    ${textColor}
`;

export const ExtAuiPrice = styled(AuiPrice)`
    ${textColor}
`;

export const ExtAuiSubHeading = styled(AuiSubHeading)`
    ${textColor}
`;

export const SubHeading2 = styled.span`
    ${subHeading2}
    ${textColor}
`;

export const InnterHTML = styled.p`
    ${subHeading2};
    ${textColor};
`;

export const ExtAuiText = styled.div<{
    size?: number;
    weight?: number;
    variant?: string;
    margin?: string;
    padding?: string;
}>`
    font-style: normal;
    font-size: ${(props: any) => props.size || 14}px;
    line-height: ${(props: any) => (props.size || 14) + 6}px;
    color: ${(props: any) => props.color};
    font-weight: ${(props: any) =>
        props.weight || props.variant === 'primary' ? '500' : '400'};
    ${(props: any) => props.margin && `margin: ${props.margin}`};
    ${(props: any) => props.padding && `padding: ${props.margin}`};
`;
